<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->

@if (user$ | async; as user) {
    <div class="wrapper">
        <app-subscription-heading [subscription]="subscription" [licensesUsed]="subscription.pba_used" [title]="title"></app-subscription-heading>
        <mat-card appearance="raised" class="card-wrapper">
            <mat-card-header>
              <mat-card-title>
                {{ 'products.included-software-title' | translate }}
              </mat-card-title>
            </mat-card-header>
            <table mat-table [dataSource]="data" aria-label="Information about included hardware software products">
                <ng-container matColumnDef="productName">
                    <th mat-header-cell *matHeaderCellDef>{{'products.product-name' | translate}}</th>
                    <td mat-cell *matCellDef="let software">
                     <span *ngIf="software.licensesApply; else justTheName">
                         @if (user.role === UserRole.ADMIN) {
                            <a id="assign-{{subscription.subscription_id}}" [routerLink]="['/assign', subscription.subscription_id]"
                               [state]="{raid: this.raid, subscription: subscription}">{{software.productName}}</a>
                         } @else {
                             {{software.productName}}
                         }
                     </span>
                        <ng-template #justTheName>
                            <span>{{software.productName}}</span>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="assignedLicenses">
                    <th mat-header-cell *matHeaderCellDef>{{'products.assigned-licenses' | translate}}</th>
                    <td mat-cell *matCellDef="let software">
                    <span *ngIf="software.canAssign">
                        {{software.assignedLicenses | number}}
                    </span>
                        <span *ngIf="!software.canAssign && !software.hasEndpoints">
                        <span>{{'N_A' | translate}}</span>
                    </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="purchasedQuantity">
                    <th mat-header-cell *matHeaderCellDef>{{'products.purchased-quantity' | translate}}</th>
                    <td mat-cell *matCellDef="let software">{{software.purchasedQuantity | number}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
            </table>
        </mat-card>
    </div>
}